import { useDraggable } from "@dnd-kit/core";
import {
  Type,
  Image,
  MousePointer2,
  Minus,
  Share2,
  Columns,
  Square,
  Code,
  List,
} from "lucide-react";

const blockTypes = [
  { id: "text", label: "Text", icon: Type, description: "Paragraph or heading" },
  { id: "image", label: "Image", icon: Image, description: "Add an image" },
  { id: "button", label: "Button", icon: MousePointer2, description: "Call to action" },
  { id: "divider", label: "Divider", icon: Minus, description: "Horizontal line" },
  { id: "spacer", label: "Spacer", icon: Square, description: "Empty space" },
  { id: "social", label: "Social", icon: Share2, description: "Social media links" },
  { id: "columns", label: "Columns", icon: Columns, description: "Multi-column layout" },
  { id: "list", label: "List", icon: List, description: "Bullet or numbered list" },
  { id: "html", label: "HTML", icon: Code, description: "Custom HTML code" },
];

const DraggableBlock = ({ block }) => {
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id: `palette-${block.id}`,
    data: { type: "palette", blockType: block.id },
  });

  const Icon = block.icon;

  return (
    <div
      ref={setNodeRef}
      {...listeners}
      {...attributes}
      className={`
        flex items-center gap-3 p-3 rounded-lg border border-border/50 bg-background
        cursor-grab active:cursor-grabbing hover:border-primary/50 hover:bg-primary/5
        transition-all
        ${isDragging ? "opacity-50 scale-95" : ""}
      `}
    >
      <div className="w-8 h-8 rounded bg-primary/10 flex items-center justify-center flex-shrink-0">
        <Icon className="h-4 w-4 text-primary" />
      </div>
      <div className="min-w-0">
        <p className="font-medium text-sm">{block.label}</p>
        <p className="text-xs text-muted-foreground truncate">{block.description}</p>
      </div>
    </div>
  );
};

const BlockPalette = () => {
  return (
    <div className="space-y-2">
      {blockTypes.map((block) => (
        <DraggableBlock key={block.id} block={block} />
      ))}
    </div>
  );
};

export default BlockPalette;
